import { useSyncExternalStore } from "react";

/**
 * Poll interval so toggling `window.__HERALD_DEBUG_TOOL_CALLS__` in the console
 * updates the UI without a full reload (dev only).
 */
const DEV_FLAG_POLL_MS = 400;

/** Single interval shared by all `useHeraldDebugToolCallsEnabled` subscribers (one per message in dev). */
const listeners = new Set<() => void>();
/** Browser timer handle (`window.setInterval`); avoid `setInterval` alone so Node's `Timeout` typing does not clash. */
let pollIntervalId: number | null = null;

const notifyListeners = () => {
  for (const listener of listeners) {
    listener();
  }
};

const subscribe = (onStoreChange: () => void) => {
  if (!import.meta.env.DEV) {
    return () => {};
  }
  listeners.add(onStoreChange);
  if (pollIntervalId === null) {
    pollIntervalId = window.setInterval(notifyListeners, DEV_FLAG_POLL_MS);
  }
  return () => {
    listeners.delete(onStoreChange);
    if (listeners.size === 0 && pollIntervalId !== null) {
      window.clearInterval(pollIntervalId);
      pollIntervalId = null;
    }
  };
};

const getSnapshot = () => {
  if (!import.meta.env.DEV) {
    return false;
  }
  return window.__HERALD_DEBUG_TOOL_CALLS__ === true;
};

const getServerSnapshot = () => false;

/**
 * Whether Herald should render raw tool-call UI (dev only, opt-in via `window.__HERALD_DEBUG_TOOL_CALLS__`).
 * Always `false` in production.
 *
 * Uses one module-level poll interval for all subscribers so long threads do not stack intervals.
 */
export const useHeraldDebugToolCallsEnabled = () =>
  useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
